import { render, staticRenderFns } from "./PieCharts.vue?vue&type=template&id=695bbb11&scoped=true&"
import script from "./PieCharts.vue?vue&type=script&lang=js&"
export * from "./PieCharts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "695bbb11",
  null
  
)

export default component.exports